












import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import CardIconList from '@/components/CardLists/CardIconList.vue'

@Component
class SectionCardIcon extends mixins(SectionCore) {
  @Prop() readonly list: ReadonlyArray<any> = []
  @Prop() readonly clipAngles: Boolean = false
}

export default defineComponent({
  name: 'SectionCardIcon',
  components: {
    CardIconList,
    SectionBasic,
  },
  props: SectionCardIcon.options.props,
})
